import $ from 'jquery'
import store from '../store'
import { qs, qsa } from '../utils'

class Menu {
  DOM

  constructor() {
    this.DOM = {}
    this.DOM.el = qs('header')
    this.DOM.burger = qs('.toggle-nav')
    this.DOM.header = qs('header')

    this.init()
  }

  init() {
    this.binds()
    this.DOM.el.classList.toggle('is-inview')
  }

  binds() {
    this.navSubMenuSet()
    this?.DOM?.burger?.addEventListener('click', () => {
      this.DOM.el?.classList?.toggle?.('active')
      // this.DOM.el.classList.toggle('is-inview');
      this.DOM.burger?.classList?.toggle?.('active')
      store.dom.header?.classList?.toggle?.('menu-open')
      qs('body')?.classList?.toggle?.('nav-open')
    })
  }

  close() {
    // this.DOM.el.classList.remove('active');
    // this.DOM.el.classList.remove('is-inview');
    // this.DOM.burger.classList.remove('active');
    this.DOM.el?.classList?.remove?.('active')
    // this.DOM.el.classList.remove('is-inview');
    this.DOM?.burger?.classList?.remove?.('active')
    store.dom.header?.classList?.remove?.('menu-open')
    qs('body').classList.remove('nav-open')
    $('.nav-hide')?.slideUp?.()
    qs('.h-s-hide-arrow')?.classList?.remove?.('active')
  }

  navSubMenuSet() {
    var $subMenues = qsa('.nav-option')

    $subMenues.forEach(($subMenu) => {
      var $arrow = qs('.h-s-hide-arrow', $subMenu)
      $arrow.addEventListener('click', () => {
        if (!$arrow.classList.contains('active')) {
          $('.nav-hide').slideUp()
          qsa('.h-s-hide-arrow').forEach(($el) => {
            $el.classList.remove('active')
          })
          // $arrow.classList.add('active');
        }
        $(qs('.nav-hide', $subMenu)).slideToggle()
        qs('.nav-hide', $subMenu).classList.toggle('active')
        $arrow.classList.toggle('active')
      })
    })
  }
}

export default Menu
